import React, { useState } from 'react';
import { OtpInputProps } from '../../types';

const OtpInput: React.FC<OtpInputProps> = ({ value, onChange, inputRef }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/\D/g, '').slice(0, 6);
    onChange(input);
  };

  const handleBoxClick = () => {
    inputRef.current?.focus();
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="otp-container" onClick={handleBoxClick}>
      <input
        type="text"
        maxLength={6}
        value={value}
        onChange={handleInputChange}
        ref={inputRef}
        className="otp-hidden-input"
        autoFocus
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {[...Array(6)].map((_, i) => {
        const char = value[i];
        const isActive = isFocused && (
          (i === value.length && value.length < 6) || 
          (i === 5 && value.length >= 6)
        );

        return (
          <div className={`otp-box ${isActive ? 'active' : ''}`} key={i}>
            {char ? (
              char
            ) : isActive ? (
              <span className="caret">|</span>
            ) : (
              <span className="placeholder">-</span>
            )}
          </div>
        );
      })}
    </div>
  );
};


export default OtpInput; 